import { Reveal } from "./Reveal";
import { api } from "../lib/api";
import { FileDown, Eye, Users, Scale } from "lucide-react";

const trackDownload = () => {
  if (localStorage.getItem("oic_esclusa") === "1") return;
  api.post("/track", { path: "/download/brochure", referrer: "", type: "download" }).catch(() => {});
};

export const MaterialsSection = () => (
  <section id="materiale" data-testid="materials-section" className="py-20 lg:py-32 bg-sand border-y border-ink/10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 mb-12 lg:mb-16">
        <Reveal className="lg:col-span-6">
          <p className="overline-tag mb-4">Materiale informativo</p>
          <h2 className="font-serif font-semibold text-ink tracking-tight text-2xl sm:text-3xl lg:text-4xl leading-tight">
            Da leggere con calma, da condividere con chi ne ha bisogno.
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-6 lg:pt-12">
          <div className="flex flex-col gap-4">
            <p className="text-base sm:text-lg leading-relaxed text-mist">
              Scarica gratuitamente i materiali: pensati sia per chi sta vivendo un momento
              familiare delicato, sia per gli avvocati che vogliono proporre la mediazione
              ai propri clienti.
            </p>
            <div className="flex flex-wrap gap-3">
              <span className="inline-flex items-center gap-2 rounded-full bg-white border border-ink/15 px-4 py-2 text-sm text-ink/80">
                <Users size={15} className="text-golddeep" /> Per le famiglie
              </span>
              <span className="inline-flex items-center gap-2 rounded-full bg-white border border-ink/15 px-4 py-2 text-sm text-ink/80">
                <Scale size={15} className="text-golddeep" /> Per gli avvocati
              </span>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        <Reveal>
          <article data-testid="material-card-brochure"
            className="group h-full bg-white border border-ink/10 rounded-2xl overflow-hidden hover:-translate-y-1.5 hover:border-gold/60 hover:shadow-[0_24px_50px_-30px_rgba(20,41,46,0.35)] transition-all duration-500">
            <div className="bg-paper border-b border-ink/10 overflow-hidden">
              <img src="/assets/brochure-cover.png" alt="Copertina della brochure Oltre il Conflitto"
                loading="lazy" className="w-full h-52 object-cover object-top group-hover:scale-[1.03] transition-transform duration-700" />
            </div>
            <div className="p-7">
              <p className="font-display text-[11px] uppercase tracking-[0.2em] text-golddeep font-semibold">Brochure · PDF · 2 pagine</p>
              <h3 className="mt-3 font-serif font-semibold text-ink text-xl leading-snug">
                Oltre il Conflitto — la mediazione familiare spiegata con parole chiare
              </h3>
              <p className="mt-3 text-sm text-mist leading-relaxed">
                Cos'è, a chi serve, come funziona e quanto costa: un'introduzione essenziale
                e rigorosa, da leggere personalmente o da condividere con i propri clienti.
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <a href="/assets/brochure-oltre-il-conflitto.pdf" download="Brochure-Oltre-il-Conflitto.pdf"
                  onClick={trackDownload} data-testid="brochure-download-button"
                  className="inline-flex items-center gap-2 rounded-full bg-ink text-paper text-sm font-semibold px-5 py-2.5 hover:bg-night hover:-translate-y-0.5 active:scale-95 transition-all duration-300">
                  <FileDown size={16} /> Scarica il PDF
                </a>
                <a href="/assets/brochure-oltre-il-conflitto.pdf" target="_blank" rel="noopener noreferrer"
                  onClick={trackDownload} data-testid="brochure-view-button"
                  className="inline-flex items-center gap-2 rounded-full border border-ink/20 text-ink text-sm font-semibold px-5 py-2.5 hover:border-gold hover:text-golddeep transition-colors duration-300">
                  <Eye size={16} /> Sfoglia online
                </a>
              </div>
            </div>
          </article>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="h-full rounded-2xl border-2 border-dashed border-ink/15 p-7 flex flex-col justify-center">
            <p className="font-display text-[11px] uppercase tracking-[0.2em] text-mist font-semibold">In arrivo</p>
            <h3 className="mt-3 font-serif font-semibold text-ink text-xl leading-snug">
              Nuovi materiali in preparazione
            </h3>
            <p className="mt-3 text-sm text-mist leading-relaxed">
              Guide di approfondimento e schede pratiche verranno aggiunte qui.
              Sei un avvocato e vorresti materiale dedicato ai tuoi clienti, o una presentazione
              del percorso? Scrivimi: lo prepariamo insieme.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
